import { useEffect, useState, useRef, useContext } from 'react';
import {
  AgentPage,
  AgentDetail,
  UploadPhotoWrapper,
  UploadPhotoIcon,
  InputFile,
  AgentInfoWrapper,
  AgentEmailPasswordWrapper,
  InputGroup,
  AgentNameWrapper,
  AgentDetailsWrapper,
  AgentDetailsInput,
  AgentDetailExtra,
  AgentContactContainer,
  AgentContactWrapper,
  AgentContactListItem,
  Input,
  AgentAdditionalDetailsContainer,
  AgentOfficeAddress,
  AgentCompanyWebsite,
  AgentCityStateServedContainer,
  AgentCityStateServed,
  AgentDetailsBio,
  AgentFooter,
  IconWrapper,
} from '../../components/agent';
import { INIT_DATA_OFFICER } from '../../components/agent/data';
import { getUserType } from '../../utils/common';
import { checkEmail, updateCommunityPhotos } from '../../services/admin';
import { hasMinimumCharacters, isEmpty, isValidEmail } from '../../utils/form';
import { styled } from 'styled-components';
import { MainContext } from '../../context';
import ReactCrop from 'react-image-crop';
import { Box, Button, Dialog } from '@mui/material';
import { CropLoading, CropperButtons } from './editagent';
import Loader from '../../components/loader';
import centerAspectCrop from '../../utils/centerAspectRatio';
import getCroppedImg from '../../utils/getCroppedImage';
import { AGENT_PROFILE_URL, LOAN_OFFICER_PROFILE_URL, getStateByCode } from '../../constants/common';
import { OfficerAddressWrapper } from './officer';

export const FieldErrorMessage = styled.p`
  color: red !important;
  font-weight: 300 !important;
  font-size: 16px !important;
`;

export const OfficerAddressWrapperThreeColumn = styled(OfficerAddressWrapper) `
    padding: 0 64px;
    & .office_address-wrapper {
        flex: 0 0 calc(33.333% - 2rem);
        padding: 0px;
    }

`
const AddOfficer = ({ handleSubmit, isSubmitting, fieldErrors = {}, officer = null }) => {
  const imgRef = useRef(null);
  const [showEditPhoto, setShowEditPhoto] = useState(false);
  const [showUploadPhoto, setShowUploadPhoto] = useState(false);
  const [error, setError] = useState(false);
  const [completedCrop, setCompletedCrop] = useState(null);
  const [cropLoading, setCropLoading] = useState(true);
  const [crop, setCrop] = useState({ unit: '%', width: 50, aspect: 1 });
  const [data, setData] = useState(officer || INIT_DATA_OFFICER);
  const [_fieldErrors, _setFieldErrors] = useState(fieldErrors);
  const isAdmin = getUserType() == 2;
  const { setActiveOfficer } = useContext(MainContext);
  const handleInputChange = async (e) => {
    const { name, value } = e.target;

    setData({
      ...data,
      [name]: value,
    });

    _setFieldErrors({
      ..._fieldErrors,
      [name]: ''
    });
  };

  const handleEmailCheck = async (e) => {
    const { name, value } = e.target;
    const checkEmailResponse = await checkEmail({ email: value });
    if (checkEmailResponse.result) {
      setData({
        ...data,
        [name]: value,
      });
    } else {
      _setFieldErrors({
        ..._fieldErrors,
        email: checkEmailResponse.errors.email,
      });
    }
  };
  // eslint-disable-next-line no-unused-vars
  const handleSelectChange = (name, sdata) => {
    setData({
      ...data,
      [name]: sdata,
    });
  };

  const [previewImage, setPreviewImage] = useState(false);

  const handleImageChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      setData({
        ...data,
        photo: file,
      });
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
        setShowEditPhoto(true);
        setCropLoading(false);
      };
      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {
    setActiveOfficer(data)
  }, [data]);
  useEffect(() => {
    if(officer && Object.keys(officer).length > 0) {
        setData({
            ...officer,
            state_licenses: officer.state_licenses.split(',').map(s => { return {name: getStateByCode(s), value: s}}),
            assigned_agents: JSON.parse(officer.assigned_agents)
        })

        if(officer.headshot) {
            setPreviewImage(officer.headshot)
        }
    }
  }, [officer]);

  useEffect(() => {
    _setFieldErrors(fieldErrors)
  }, [fieldErrors]);

  const {
    first_name,
    last_name,
    office_phone,
    direct_phone,
    mobile_phone,
    email,
    personal_email,
    chime_user_id,
    nmls,
    state_licenses,
    personal_website_url,
    loan_application_url,
    linkedin_url,
    facebook_url,
    instagram_url,
    tiktok_url,
    twitter_url,
    office_address,
    office_city,
    office_state,
    office_zip,
    company_name,
    company_nmls,
    company_license_disclosure,
    company_office_address,
    company_office_city,
    company_office_state,
    company_office_zip,
    company_url,
    branch_name,
    manager_name,
    recruited_by,
    compensation_plan,
    onboarded_date,
    headshot,
    assistant_first_name,
    assistant_last_name,
    assistant_email,
    assistant_direct_phone,
    primary_zip_codes,
    assigned_agents,
    description
  } = data;

  const refEmail = useRef();
  const refLastName = useRef();
  const refFirstName = useRef();
  const refCompanyName = useRef();
  const refMobilePhone = useRef();
  const refNmls = useRef();
  const refCompanyNmls = useRef();
  const refCompanyAddress = useRef();
  const refCompanyCity = useRef();
  const refCompanyState = useRef();
  const refCompanyZip = useRef();
  const refCompanyDisclosure = useRef();
  const refCompanyUrl = useRef();
  

  useEffect(() => setActiveOfficer(data), [data]);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (isEmpty(first_name)) {
    _setFieldErrors({
      ..._fieldErrors,
      first_name: 'First name is required',
    });
    refFirstName.current.scrollIntoView();
  } else if (isEmpty(last_name)) {
    _setFieldErrors({
      ..._fieldErrors,
      last_name: 'Last name is required',
    });
    refLastName.current.scrollIntoView();
  }
  else if (isEmpty(nmls)) {
    _setFieldErrors({
      ..._fieldErrors,
      nmls: 'NMLS is required',
    });
    refNmls.current.scrollIntoView();
  }  else if (isEmpty(mobile_phone)) {
    _setFieldErrors({
      ..._fieldErrors,
      mobile_phone: 'Mobile phone is required',
    });
    refMobilePhone.current.scrollIntoView();
  } 
    else if (isEmpty(email)) {
      _setFieldErrors({
        ..._fieldErrors,
        email: 'Email is required.',
      });
      refEmail.current.scrollIntoView();
    } else if (!isValidEmail(email)) {
      _setFieldErrors({
        ..._fieldErrors,
        email: 'Email is not valid.',
      });
      refEmail.current.scrollIntoView();
    }  else if (isEmpty(company_name)) {
      _setFieldErrors({
        ..._fieldErrors,
        company_name: 'Company name is required',
      });
        refCompanyName.current.scrollIntoView();
    }  else if (isEmpty(company_nmls)) {
        _setFieldErrors({
          ..._fieldErrors,
          company_nmls: 'Company NMLS is required',
        });
          refCompanyNmls.current.scrollIntoView();
    } else if (isEmpty(company_office_address)) {
        _setFieldErrors({
          ..._fieldErrors,
          company_office_address: 'Company address is required',
        });
          refCompanyAddress.current.scrollIntoView();
      }    
      else if (isEmpty(company_office_city)) {
        _setFieldErrors({
          ..._fieldErrors,
          company_office_city: 'Company city is required',
        });
          refCompanyCity.current.scrollIntoView();
      } 
      else if (isEmpty(company_office_state)) {
        _setFieldErrors({
          ..._fieldErrors,
          company_office_state: 'Company state is required',
        });
          refCompanyState.current.scrollIntoView();
      } 
      else if (isEmpty(company_office_zip)) {
        _setFieldErrors({
          ..._fieldErrors,
          company_office_zip: 'Company zip is required',
        });
          refCompanyZip.current.scrollIntoView();
      }  
      else if (isEmpty(company_license_disclosure)) {
        _setFieldErrors({
          ..._fieldErrors,
          company_license_disclosure: 'Company disclosure is required',
        });
          refCompanyDisclosure.current.scrollIntoView();
      }
      else if (isEmpty(company_url)) {
        _setFieldErrors({
          ..._fieldErrors,
          company_url: 'Company url is required',
        });
          refCompanyUrl.current.scrollIntoView();
      }         
    else handleSubmit(data);
  };

  const onImageLoad = (e) => {
    const { width, height } = e.currentTarget;

    setCrop(centerAspectCrop(width, height, 1));
  };

  const handleSavePhoto = async () => {
    setCropLoading(true);
    try {
      const imageData = await getCroppedImg(imgRef.current, completedCrop);

      const { blob, base64Image } = imageData;
      setPreviewImage(base64Image);
      setData({ ...data, headshot:blob });
      setShowEditPhoto(false);
    } catch (error) {
      console.log(error);
    } finally {
      setCropLoading(false);
    }
  };

  return (
    <form onSubmit={handleFormSubmit} method="POST">
      <AgentPage>
        <Dialog open={showEditPhoto} onClose={() => setShowEditPhoto(false)} maxWidth="lg">
          {cropLoading ? (
            <CropLoading>
              <Loader />
            </CropLoading>
          ) : (
            <>
              <ReactCrop
                crop={crop}
                onChange={(_, percentCrop) => setCrop(percentCrop)}
                onComplete={(c) => setCompletedCrop(c)}
                aspect={1}
              >
                <Box
                  component="img"
                  src={previewImage}
                  width="100%"
                  ref={imgRef}
                  sx={{ mx: 'auto' }}
                  onLoad={onImageLoad}
                />
              </ReactCrop>
              <CropperButtons>
                <Button onClick={handleSavePhoto}>SAVE</Button>
              </CropperButtons>
            </>
          )}
        </Dialog>
        <AgentDetail>
          <UploadPhotoWrapper>
            {previewImage && !error ? (
              <>
                <img
                  style={{ objectFit: 'cover', objectPosition: 'top center' }}
                  src={previewImage?.includes('data') ? previewImage : LOAN_OFFICER_PROFILE_URL + headshot}
                  alt="Preview"
                  onClick={() => document.getElementById('photo').click()}
                  onMouseEnter={() => setShowUploadPhoto(true)}
                  onError={(e) => setError(true)}
                />
                {showUploadPhoto && (
                  <UploadPhotoIcon
                    onMouseLeave={() => setShowUploadPhoto(false)}
                    onClick={() => document.getElementById('photo').click()}
                    style={{ borderRadius: '50%', backgroundColor: 'rgb(0, 0, 0, .7)', position: 'absolute' }}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="76" height="76" viewBox="0 0 76 76" fill="none">
                      <path
                        d="M61.1975 43.347C60.2506 43.347 59.3424 43.7232 58.6728 44.3928C58.0033 45.0624 57.6271 45.9705 57.6271 46.9175V48.2743L52.3428 42.99C50.477 41.1389 47.9552 40.1002 45.3269 40.1002C42.6986 40.1002 40.1768 41.1389 38.311 42.99L35.8117 45.4893L26.957 36.6346C25.0651 34.8337 22.5531 33.8293 19.9411 33.8293C17.329 33.8293 14.8171 34.8337 12.9251 36.6346L7.64089 41.9189V21.9244C7.64089 20.9774 8.01706 20.0693 8.68664 19.3997C9.35623 18.7301 10.2644 18.3539 11.2113 18.3539H36.2044C37.1514 18.3539 38.0595 17.9778 38.7291 17.3082C39.3987 16.6386 39.7749 15.7304 39.7749 14.7835C39.7749 13.8366 39.3987 12.9284 38.7291 12.2588C38.0595 11.5892 37.1514 11.2131 36.2044 11.2131H11.2113C8.37051 11.2131 5.64604 12.3416 3.63728 14.3503C1.62851 16.3591 0.5 19.0836 0.5 21.9244V64.7697C0.5 67.6105 1.62851 70.335 3.63728 72.3438C5.64604 74.3525 8.37051 75.481 11.2113 75.481H54.0566C56.8975 75.481 59.6219 74.3525 61.6307 72.3438C63.6395 70.335 64.768 67.6105 64.768 64.7697V46.9175C64.768 45.9705 64.3918 45.0624 63.7222 44.3928C63.0526 43.7232 62.1445 43.347 61.1975 43.347ZM11.2113 68.3401C10.2644 68.3401 9.35623 67.964 8.68664 67.2944C8.01706 66.6248 7.64089 65.7166 7.64089 64.7697V52.0232L17.9952 41.6689C18.5197 41.1691 19.2165 40.8902 19.9411 40.8902C20.6656 40.8902 21.3624 41.1691 21.887 41.6689L33.2053 52.9872L48.5582 68.3401H11.2113ZM57.6271 64.7697C57.6219 65.4532 57.3966 66.1168 56.9844 66.662L40.8817 50.4879L43.381 47.9886C43.637 47.7274 43.9425 47.5198 44.2797 47.3781C44.6169 47.2364 44.979 47.1634 45.3448 47.1634C45.7105 47.1634 46.0726 47.2364 46.4098 47.3781C46.747 47.5198 47.0525 47.7274 47.3085 47.9886L57.6271 58.3786V64.7697ZM74.4439 12.2485L63.7325 1.53716C63.393 1.2121 62.9926 0.957296 62.5543 0.787363C61.685 0.430254 60.71 0.430254 59.8408 0.787363C59.4025 0.957296 59.0021 1.2121 58.6625 1.53716L47.9512 12.2485C47.2789 12.9208 46.9011 13.8327 46.9011 14.7835C46.9011 15.7343 47.2789 16.6462 47.9512 17.3185C48.6235 17.9908 49.5354 18.3685 50.4862 18.3685C51.437 18.3685 52.3489 17.9908 53.0212 17.3185L57.6271 12.6769V32.6357C57.6271 33.5826 58.0033 34.4908 58.6728 35.1604C59.3424 35.83 60.2506 36.2062 61.1975 36.2062C62.1445 36.2062 63.0526 35.83 63.7222 35.1604C64.3918 34.4908 64.768 33.5826 64.768 32.6357V12.6769L69.3738 17.3185C69.7058 17.6532 70.1007 17.9188 70.5357 18.1C70.9708 18.2813 71.4375 18.3746 71.9089 18.3746C72.3802 18.3746 72.8469 18.2813 73.282 18.1C73.7171 17.9188 74.1119 17.6532 74.4439 17.3185C74.7785 16.9866 75.0441 16.5917 75.2254 16.1566C75.4067 15.7215 75.5 15.2548 75.5 14.7835C75.5 14.3122 75.4067 13.8455 75.2254 13.4104C75.0441 12.9753 74.7785 12.5804 74.4439 12.2485Z"
                        fill="#A8A8A8"
                      />
                    </svg>
                    <h5>UPLOAD PHOTO</h5>
                  </UploadPhotoIcon>
                )}
              </>
            ) : (
              <UploadPhotoIcon onClick={() => document.getElementById('photo').click()}>
                <svg xmlns="http://www.w3.org/2000/svg" width="76" height="76" viewBox="0 0 76 76" fill="none">
                  <path
                    d="M61.1975 43.347C60.2506 43.347 59.3424 43.7232 58.6728 44.3928C58.0033 45.0624 57.6271 45.9705 57.6271 46.9175V48.2743L52.3428 42.99C50.477 41.1389 47.9552 40.1002 45.3269 40.1002C42.6986 40.1002 40.1768 41.1389 38.311 42.99L35.8117 45.4893L26.957 36.6346C25.0651 34.8337 22.5531 33.8293 19.9411 33.8293C17.329 33.8293 14.8171 34.8337 12.9251 36.6346L7.64089 41.9189V21.9244C7.64089 20.9774 8.01706 20.0693 8.68664 19.3997C9.35623 18.7301 10.2644 18.3539 11.2113 18.3539H36.2044C37.1514 18.3539 38.0595 17.9778 38.7291 17.3082C39.3987 16.6386 39.7749 15.7304 39.7749 14.7835C39.7749 13.8366 39.3987 12.9284 38.7291 12.2588C38.0595 11.5892 37.1514 11.2131 36.2044 11.2131H11.2113C8.37051 11.2131 5.64604 12.3416 3.63728 14.3503C1.62851 16.3591 0.5 19.0836 0.5 21.9244V64.7697C0.5 67.6105 1.62851 70.335 3.63728 72.3438C5.64604 74.3525 8.37051 75.481 11.2113 75.481H54.0566C56.8975 75.481 59.6219 74.3525 61.6307 72.3438C63.6395 70.335 64.768 67.6105 64.768 64.7697V46.9175C64.768 45.9705 64.3918 45.0624 63.7222 44.3928C63.0526 43.7232 62.1445 43.347 61.1975 43.347ZM11.2113 68.3401C10.2644 68.3401 9.35623 67.964 8.68664 67.2944C8.01706 66.6248 7.64089 65.7166 7.64089 64.7697V52.0232L17.9952 41.6689C18.5197 41.1691 19.2165 40.8902 19.9411 40.8902C20.6656 40.8902 21.3624 41.1691 21.887 41.6689L33.2053 52.9872L48.5582 68.3401H11.2113ZM57.6271 64.7697C57.6219 65.4532 57.3966 66.1168 56.9844 66.662L40.8817 50.4879L43.381 47.9886C43.637 47.7274 43.9425 47.5198 44.2797 47.3781C44.6169 47.2364 44.979 47.1634 45.3448 47.1634C45.7105 47.1634 46.0726 47.2364 46.4098 47.3781C46.747 47.5198 47.0525 47.7274 47.3085 47.9886L57.6271 58.3786V64.7697ZM74.4439 12.2485L63.7325 1.53716C63.393 1.2121 62.9926 0.957296 62.5543 0.787363C61.685 0.430254 60.71 0.430254 59.8408 0.787363C59.4025 0.957296 59.0021 1.2121 58.6625 1.53716L47.9512 12.2485C47.2789 12.9208 46.9011 13.8327 46.9011 14.7835C46.9011 15.7343 47.2789 16.6462 47.9512 17.3185C48.6235 17.9908 49.5354 18.3685 50.4862 18.3685C51.437 18.3685 52.3489 17.9908 53.0212 17.3185L57.6271 12.6769V32.6357C57.6271 33.5826 58.0033 34.4908 58.6728 35.1604C59.3424 35.83 60.2506 36.2062 61.1975 36.2062C62.1445 36.2062 63.0526 35.83 63.7222 35.1604C64.3918 34.4908 64.768 33.5826 64.768 32.6357V12.6769L69.3738 17.3185C69.7058 17.6532 70.1007 17.9188 70.5357 18.1C70.9708 18.2813 71.4375 18.3746 71.9089 18.3746C72.3802 18.3746 72.8469 18.2813 73.282 18.1C73.7171 17.9188 74.1119 17.6532 74.4439 17.3185C74.7785 16.9866 75.0441 16.5917 75.2254 16.1566C75.4067 15.7215 75.5 15.2548 75.5 14.7835C75.5 14.3122 75.4067 13.8455 75.2254 13.4104C75.0441 12.9753 74.7785 12.5804 74.4439 12.2485Z"
                    fill="#A8A8A8"
                  />
                </svg>
                <h5>UPLOAD PHOTO</h5>
              </UploadPhotoIcon>
            )}
            <InputFile name="photo" type="file" accept="image/*" id="photo" onChange={handleImageChange} />
          </UploadPhotoWrapper>
          <AgentInfoWrapper>
            <AgentNameWrapper>
              <Input
                className={(_fieldErrors.first_name && 'has-error') || ''}
                placeholder="First Name"
                ref={refFirstName}
                minLength={4}
                name="first_name"
                value={first_name}
                onChange={handleInputChange}
              />
              {_fieldErrors.first_name && <FieldErrorMessage>{_fieldErrors.first_name}</FieldErrorMessage>}

              <Input
                className={(_fieldErrors.last_name && 'has-error') || ''}
                placeholder="Last Name"
                name="last_name"
                ref={refLastName}
                value={last_name}
                onChange={handleInputChange}
              />
              {_fieldErrors.last_name && <FieldErrorMessage>{_fieldErrors.last_name}</FieldErrorMessage>}
            </AgentNameWrapper>
            <AgentDetailsWrapper>
              <AgentDetailsInput
                className={(_fieldErrors.nmls && 'has-error') || ''}
                label="NMLS #"
                name="nmls"
                ref={refNmls}
                value={nmls}
                onChange={handleInputChange}
                placeholder={'MMLS Number'}
                
              />
              {_fieldErrors.nmls && <FieldErrorMessage>{_fieldErrors.nmls}</FieldErrorMessage>}
              
              <AgentDetailsInput
                className={(_fieldErrors.first_name && 'has-error') || ''}
                ref={refMobilePhone}
                label="Mobile #"
                name="mobile_phone"
                value={mobile_phone}
                onChange={handleInputChange}
                placeholder={'Mobile Number'}
              />
              {_fieldErrors.mobile_phone && <FieldErrorMessage>{_fieldErrors.mobile_phone}</FieldErrorMessage>}
              <AgentDetailsInput
                label="Office #"
                name="office_phone"
                value={office_phone}
                onChange={handleInputChange}
                placeholder={'Office Number'}
              />
              <AgentDetailsInput
                label="Direct #"
                name="direct_phone"
                value={direct_phone}
                onChange={handleInputChange}
                placeholder={'Direct Number'}
              />
            <AgentDetailsInput
                className={(_fieldErrors.email && 'has-error') || ''}
                label="Email"
                name="email"
                value={email}
                ref={refEmail}
                onChange={handleInputChange}
                placeholder={'Main Email'}
              />
              {_fieldErrors.email && <FieldErrorMessage>{_fieldErrors.email}</FieldErrorMessage>}
              
             <AgentDetailsInput
                label="Personal Email"
                name="personal_email"
                value={personal_email}
                onChange={handleInputChange}
                placeholder={'Personal Email'}
              />
              {/* <AgentDetailsInput
                label="CHIME USER ID"
                name="chime_user_id"
                value={chime_user_id}
                onChange={handleInputChange}
                placeholder={'Chime user id'}
              />*/}
            </AgentDetailsWrapper> 
          </AgentInfoWrapper>
        </AgentDetail>

        <AgentDetailExtra>
          <AgentContactContainer>
            <AgentContactWrapper>
              <AgentContactListItem
                title="Loan Application URL"
                name="loan_application_url"
                value={loan_application_url}
                onChange={handleInputChange}
                icon="website"
              />
             <AgentContactListItem
                title="LinkedIn URL"
                name="linkedin_url"
                value={linkedin_url}
                onChange={handleInputChange}
                icon="website"
              />
             <AgentContactListItem
                title="Facebook URL"
                name="facebook_url"
                value={facebook_url}
                onChange={handleInputChange}
                icon="website"
              />
            <AgentContactListItem
                title="Instagram URL"
                name="instagram_url"
                value={instagram_url}
                onChange={handleInputChange}
                icon="website"
              />
            <AgentContactListItem
                title="Tiktol URL"
                name="tiktok_url"
                value={tiktok_url}
                onChange={handleInputChange}
                icon="website"
              />
            <AgentContactListItem
                title="Twitter URL"
                name="twitter_url"
                value={twitter_url}
                onChange={handleInputChange}
                icon="website"
              />
            <AgentContactListItem
                title="Branch Name"
                name="branch_name"
                value={branch_name}
                onChange={handleInputChange}
                icon="team-name"
              />
            <AgentContactListItem
                title="Manager Name"
                name="manager_name"
                value={manager_name}
                onChange={handleInputChange}
                icon="team-name"
              />
                <AgentContactListItem
                title="Recruited By"
                name="recruited_by"
                value={recruited_by}
                onChange={handleInputChange}
                icon="team-name"
              />
              <AgentContactListItem
                title="Compensation Plan"
                name="compensation_plan"
                value={compensation_plan}
                onChange={handleInputChange}
                icon="compensation-plan"
              />

              <AgentContactListItem
                title="Onboarded Date"
                name="onboarded_date"
                value={onboarded_date}
                onChange={handleInputChange}
                icon="agent-type"
                type="date"
              />
            </AgentContactWrapper>
          </AgentContactContainer>
          <AgentAdditionalDetailsContainer style={{gap: '2rem'}}>
            
            <AgentOfficeAddress
            hasError={(_fieldErrors.company && 'has-error')}
            refName={refCompanyName}
            title="Company Name"
            name="company_name"
            value={company_name}
            onChange={handleInputChange}
            />
            {_fieldErrors.company_name && <FieldErrorMessage>{_fieldErrors.company_name}</FieldErrorMessage>}
              
            <AgentOfficeAddress
             hasError={(_fieldErrors.company_nmls && 'has-error')}
             refName={refCompanyNmls}
            title="Company NMLS"
            name="company_nmls"
            value={company_nmls}
            onChange={handleInputChange}
            />
            {_fieldErrors.company_nmls && <FieldErrorMessage>{_fieldErrors.company_nmls}</FieldErrorMessage>}
            <AgentOfficeAddress
               hasError={(_fieldErrors.company_office_address && 'has-error')}
                refName={refCompanyAddress}
              title="Company Office Address"
              name="company_office_address"
              value={company_office_address}
              onChange={handleInputChange}
            />
             {_fieldErrors.company_office_address && <FieldErrorMessage>{_fieldErrors.company_office_address}</FieldErrorMessage>}
            
            <OfficerAddressWrapperThreeColumn>
            <AgentOfficeAddress
               hasError={(_fieldErrors.company_office_city && 'has-error')}
               refName={refCompanyCity}
              title="Company Office City"
              name="company_office_city"
              value={company_office_city}
              onChange={handleInputChange}
            />
           
            <AgentOfficeAddress
              hasError={(_fieldErrors.company_office_state && 'has-error')}
              refName={refCompanyState}
              title="Company Office State"
              name="company_office_state"
              value={company_office_state}
              onChange={handleInputChange}
            />
            
            <AgentOfficeAddress
            hasError={(_fieldErrors.company_office_zip && 'has-error')}
            refName={refCompanyZip}
            
              title="Company Office Zip Code"
              name="company_office_zip"
              value={company_office_zip}
              onChange={handleInputChange}
            /> 
     
            </OfficerAddressWrapperThreeColumn>
            {_fieldErrors.company_office_state && <FieldErrorMessage>{_fieldErrors.company_office_state}</FieldErrorMessage>}
            
            {_fieldErrors.company_office_city && <FieldErrorMessage>{_fieldErrors.company_office_city}</FieldErrorMessage>}
           
             {_fieldErrors.company_office_zip && <FieldErrorMessage>{_fieldErrors.company_office_zip}</FieldErrorMessage>}
           
            <AgentOfficeAddress
              title="Office Address"
              name="office_address"
              value={office_address}
              onChange={handleInputChange}
            />
            <OfficerAddressWrapperThreeColumn>
            <AgentOfficeAddress
              title="Office City"
              name="office_city"
              value={office_city}
              onChange={handleInputChange}
            />
            <AgentOfficeAddress
              title="Office State"
              name="office_state"
              value={office_state}
              onChange={handleInputChange}
            />
            <AgentOfficeAddress
              title="Office Zip"
              name="office_zip"
              value={office_zip}
              onChange={handleInputChange}
            />
            </OfficerAddressWrapperThreeColumn>
            <AgentCompanyWebsite 
                companyRef={refCompanyUrl}
                hasError={(_fieldErrors.company_url && 'has-error')}
                company_website_name="company_url"
                personal_website_name="personal_website_url"
                company={company_url} 
                personal={personal_website_url}
                onChange={handleInputChange} />
                {_fieldErrors.company_url && <FieldErrorMessage>{_fieldErrors.company_url}</FieldErrorMessage>}
            
            <AgentCityStateServedContainer>
              <AgentCityStateServed
                title="state"
                name="state_licenses"
                values={state_licenses}
                onChange={handleSelectChange}
                description="States Licensed In"
              />
              {_fieldErrors.state_licenses && <FieldErrorMessage>{_fieldErrors.state_licenses}</FieldErrorMessage>}
            
                {/* <AgentCityStateServed
                title="agents"
                name="assigned_agents"
                values={assigned_agents}
                onChange={handleSelectChange}
                description="Agents Assigned"
              /> */}
            </AgentCityStateServedContainer>
            <AgentOfficeAddress
               hasError={(_fieldErrors.company_license_disclosure && 'has-error')}
               refName={refCompanyDisclosure}
              title="Company License Disclosure"
              name="company_license_disclosure"
              value={company_license_disclosure}
              onChange={handleInputChange}
            />
              {_fieldErrors.company_license_disclosure && <FieldErrorMessage>{_fieldErrors.company_license_disclosure}</FieldErrorMessage>}
            
            <AgentOfficeAddress
              title="Primary Zip Codes"
              name="primary_zip_codes"
              value={primary_zip_codes}
              onChange={handleInputChange}
            />
            <OfficerAddressWrapper style={{padding: '0 64px'}}>
             <AgentOfficeAddress
              title="Assistant First Name"
              name="assistant_first_name"
              value={assistant_first_name}
              onChange={handleInputChange}
            />
            <AgentOfficeAddress
              title="Assistant Last Name"
              name="assistant_last_name"
              value={assistant_last_name}
              onChange={handleInputChange}
            />
            <AgentOfficeAddress
              title="Assistant Email"
              name="assistant_email"
              value={assistant_email}
              onChange={handleInputChange}
            />
            <AgentOfficeAddress
              title="Assistant Direct Phone"
              name="assistant_direct_phone"
              value={assistant_direct_phone}
              onChange={handleInputChange}
            />
            </OfficerAddressWrapper>
          </AgentAdditionalDetailsContainer>
        </AgentDetailExtra>
        <AgentDetailsBio
          title="About"
          icon="bio-name"
          name="description"
          values={description}
          onChange={handleInputChange}
          type="text"
          placeholder="Officer's Bio"
        />
        <AgentFooter isSubmitting={isSubmitting} />
      </AgentPage>
    </form>
  );
};

export default AddOfficer;
